<template>
  <svg width="62" height="76" viewBox="0 0 62 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.7487 57.6667H44.2487V31.1667H61.9154L30.9987 0.25L0.0820312 31.1667H17.7487V57.6667ZM0.0820312 66.5H61.9154V75.3333H0.0820312V66.5Z"
      fill="#DCDCDC" />
  </svg>
</template>

<script>

export default {
  name: 'UploaderMediaIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped></style>
